import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CarrierDriverService } from "../service/carrier-driver.service";
import { UtilityServiceService } from 'app/services/utility-service.service';
import { OcasService } from 'app/ocas/Service/ocas.service';

@Component({
  selector: "app-carrier-driver-list",
  templateUrl: "./carrier-driver-list.component.html",
  styleUrls: ["./carrier-driver-list.component.scss"],
})
export class CarrierDriverListComponent implements OnInit {
  isLoading: boolean = false;
  carrierDriverList: any = [];
  currentPage = 1;
  page = 1;
  pageSize: number = 10;
  count: number;
  isEmpty: boolean;
  carrierId:any;
  user:any = {};
  driverId:number;
  driver:any;

  @ViewChild('add') addModal: NgbModal;
  @ViewChild('edit') editModal: NgbModal;
  @ViewChild('detail') detailModal: NgbModal;
  @Output() prevNext = new EventEmitter();
  @Input() isInStepper: boolean = false;
  @Output() nextStepEmitter = new EventEmitter<number>();
  @Output() prevStepEmitter = new EventEmitter<number>();

  closeResult:string = "";

  constructor(private _service: CarrierDriverService, private _router:Router, private _activatedRoute:ActivatedRoute, private modalService: NgbModal,private _ocas:OcasService,
    private authWebService:AuthWebService,private confirmDialogService: ConfirmDialogService,private toastService:ToastNotificationService,private utility:UtilityServiceService) {
    this.user = this.authWebService.userData
      ? this.authWebService.userData.User
      : null;
    this._activatedRoute.params.subscribe((params: Params) => {
      this.carrierId = params["id"];
    });
    if(this._router.url.includes('carrier/account/add')){
      this.carrierId = this.utility.ctrlPages[this.utility.acc.First].carrierId
    }
    
  }

  ngOnInit(): void {
    this.getDriverList();
  }

  getDriverList = (page: number = 1, pageSize: number = 10) => {
    this.isLoading = true;
    this.carrierDriverList = [];
    this._service.getDriversByCarrierId(this.carrierId).subscribe((response: any) => {
      console.log(response);
      response.forEach(depot => {
          const drivers = [...depot.driver];
          this.carrierDriverList = [...this.carrierDriverList,...drivers]
        this.count = this.carrierDriverList.length;
      });
      if (response && response.length > 0) {
        // response.forEach(depot => {
        //   if(depot.driver && depot.driver.length > 0) {
        //     const drivers = [...depot.driver];
        //     this.carrierDriverList = [...this.carrierDriverList,...drivers]
        //   }
        //   this.count = this.carrierDriverList.length;
        // });
        this.isLoading = false;
        console.log(this.carrierDriverList);
        
      } else {
        this.isEmpty = true;
        this.isLoading = false;
      }
    });
  };

  // onAddDriver() {
  //   this._router.navigate([`/carrier-driver/add/${this.carrierId}`]);
  // }

  // onEditDriver(driver: any) {
  //   this._router.navigate([
  //     `/carrier-driver/edit/${this.carrierId}/${driver.id}`,
  //   ]);
  // }

  // onViewDetails(driver: any) {
  //   this._router.navigate([
  //     `/carrier-driver/details/${this.carrierId}/${driver.id}`,
  //   ]);
  // }

  addDriverModal() {
    this.modalService.open(this.addModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.getDriverList();
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.getDriverList();
      },
    );
  }

  editDriverModal(driver) {
    if(driver) this.driverId = driver.id;
    this.modalService.open(this.editModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.getDriverList();
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onViewDetails(driver: any) {
    if(driver) this.driver = driver;
    this.modalService.open(this.detailModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onNextOrPrevious(page: number = 1) {
    this.getDriverList(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  onDeleteDriver(driver) {
    this.confirmDialogService.confirmThis('Are you sure you want to delete this driver information?', () => {  
        
      this.isLoading = true;

        this._service.delete(driver.id).subscribe(data => {
          this.carrierDriverList = [];
          this.getDriverList();
          
          this.toastService.success('The driver information was deleted successfully','success');
        this.isLoading = false;

      }, error => {
        this.isLoading = false;
        this.toastService.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.",'error');

      })
  
  }, () =>  {  
    return false;
 })
  }

  onDelete(log) {
    console.log("********");
  }
  private getDismissReason(reason: any): string {
    return 
    // if (reason === ModalDismissReasons.ESC) {
    //   return "by pressing ESC";
    // } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    //   return "by clicking on a backdrop";
    // } else {
    //   return `with: ${reason}`;
    // }
  }

  next() {
    this.prevNext.emit('next');
  }
  
  back() {
    this.prevNext.emit('back');
  }

  nextStep(){
    this.nextStepEmitter.emit(0)
  }

  prevStep(){
    this.prevStepEmitter.emit(0)
  }
}
